// Pool Analysis mock data and calculations

export const poolTypes = [
  { id: 'standard', name: 'Standard Pool', basePrice: 35000, description: 'Classic rectangular or kidney-shaped pool' },
  { id: 'luxury', name: 'Luxury Pool', basePrice: 55000, description: 'Custom design with premium features' },
  { id: 'infinity', name: 'Infinity Edge Pool', basePrice: 75000, description: 'Stunning vanishing edge design' },
  { id: 'natural', name: 'Natural Pool', basePrice: 45000, description: 'Eco-friendly with natural filtration' }
];

export const poolSizes = [
  { id: 'small', name: 'Small (12x24 ft)', multiplier: 0.8 },
  { id: 'medium', name: 'Medium (16x32 ft)', multiplier: 1.0 },
  { id: 'large', name: 'Large (20x40 ft)', multiplier: 1.3 },
  { id: 'xlarge', name: 'Extra Large (24x48 ft)', multiplier: 1.6 }
];

export const poolFeatures = [
  { id: 'waterfall', name: 'Waterfall Feature', price: 5000 },
  { id: 'heater', name: 'Pool Heater', price: 4500 },
  { id: 'lighting', name: 'LED Lighting System', price: 3000 },
  { id: 'spa', name: 'Attached Spa/Hot Tub', price: 12000 },
  { id: 'automation', name: 'Smart Automation', price: 3500 },
  { id: 'saltwater', name: 'Saltwater System', price: 2500 },
  { id: 'deck', name: 'Premium Decking', price: 8000 },
  { id: 'landscaping', name: 'Landscaping Package', price: 6000 }
];

export const calculatePoolCost = (poolType, poolSize, selectedFeatures) => {
  // Find base price from pool type
  const typeObj = poolTypes.find(t => t.id === poolType);
  if (!typeObj) return null;
  
  let basePrice = typeObj.basePrice;
  
  // Apply size multiplier
  const sizeObj = poolSizes.find(s => s.id === poolSize);
  if (sizeObj) {
    basePrice *= sizeObj.multiplier;
  }
  
  // Add features
  let featuresTotal = 0;
  selectedFeatures.forEach(featureId => {
    const feature = poolFeatures.find(f => f.id === featureId);
    if (feature) {
      featuresTotal += feature.price;
    }
  });
  
  const subtotal = basePrice + featuresTotal;
  const laborCost = subtotal * 0.25; // 25% labor
  const permitsFees = 2500;
  const total = subtotal + laborCost + permitsFees;
  
  return {
    basePrice: Math.round(basePrice),
    features: Math.round(featuresTotal),
    labor: Math.round(laborCost),
    permits: permitsFees,
    subtotal: Math.round(subtotal),
    total: Math.round(total),
    monthlyPayment: Math.round(total / 60) // 5-year financing estimate
  };
};

export const savPoolAnalysis = (analysisData) => {
  const analyses = JSON.parse(localStorage.getItem('poolAnalyses') || '[]');
  analyses.push({
    ...analysisData,
    timestamp: new Date().toISOString(),
    id: Date.now()
  });
  localStorage.setItem('poolAnalyses', JSON.stringify(analyses));
  return { success: true, message: "Your pool analysis has been saved! We'll contact you soon." };
};
